export default __webpack_public_path__ + "static/media/no_data.139dae06.svg";